export const approved = {
  title: 'GET RRROBLOX RICH',
  assistance: 'fine, maybe I got some assistance',
} as const;

/* What the browser tab shows, on every page. */
export const tabTitle = 'ROBUX CLUB Early Access';

export const socials = {
  youtube: 'https://www.youtube.com/@brandmaxinc',
  tiktok: 'https://www.tiktok.com/@sinalr',
  instagram: 'https://www.instagram.com/brandmax.inc/',
} as const;

export const filler = {
  short: 'Lorem ipsum',
  medium: 'Lorem ipsum dolor sit amet',
  sentence: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
  paragraph:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  cardTitles: [
    'Lorem ipsum dolor sit amet',
    'Consectetur adipiscing elit',
    'Sed do eiusmod tempor incididunt',
    'Ut labore et dolore magna aliqua',
    'Quis ipsum suspendisse ultrices',
  ],
  navigation: ['Lorem ipsum', 'Lorem', 'Dolor sit amet'],
} as const;
